<template>
  <wd-config-provider :themeVars="themeVars">
    <slot />
    <wd-toast />
    <wd-message-box />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'

const themeVars: ConfigProviderThemeVars = {
  colorTheme: '#008CFF',
  navbarBackground: 'transparent',
  radioLabelFs: '28rpx',
  buttonMediumHeight: '72rpx',
  buttonMediumFs: '32rpx',
}
</script>
